import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActiveInvestigationActivitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ActiveInvestigationActivitiesQuery = { readonly __typename?: 'Query', readonly catalogueInvestigationActivities: ReadonlyArray<{ readonly __typename?: 'InvestigationActivityItem', readonly id: string, readonly _id?: string | null, readonly title: string, readonly keywords?: ReadonlyArray<string | null> | null, readonly version: number, readonly activityType: string, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null } | null, readonly coding?: { readonly __typename?: 'CatalogueCoding', readonly elephant?: { readonly __typename?: 'SpecificationReference', readonly code: string } | null, readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string } | null } | null, readonly result?: { readonly __typename?: 'InvestigationItemResult', readonly resultSchema: unknown } | null } | null> };

export type InvestigationsListHashQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InvestigationsListHashQuery = { readonly __typename?: 'Query', readonly catalogueInvestigationActivitiesLastUpdated: string };

export type InvestigationActivityFragmentFragment = { readonly __typename?: 'InvestigationActivity', readonly _id: string, readonly uuid?: string | null, readonly void: boolean, readonly meta: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null }, readonly clinicalEvent?: { readonly __typename?: 'ClinicalEvent', readonly id: string, readonly type: Types.ClinicalEventType } | null, readonly catalogueItem: { readonly __typename?: 'InvestigationActivityItem', readonly _id?: string | null, readonly title: string, readonly activityType: string, readonly keywords?: ReadonlyArray<string | null> | null, readonly coding?: { readonly __typename?: 'CatalogueCoding', readonly elephant?: { readonly __typename?: 'SpecificationReference', readonly code: string } | null, readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string } | null } | null, readonly result?: { readonly __typename?: 'InvestigationItemResult', readonly resultSchema: unknown } | null, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null }, readonly request?: { readonly __typename?: 'InvestigationRequestOutcome', readonly _id: string, readonly orderedProperties: ReadonlyArray<unknown | null>, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null } | null, readonly location?: { readonly __typename?: 'InvestigationLocationSnapshot', readonly _id: string, readonly name: string } | null, readonly performer: { readonly __typename?: 'ElephantActor', readonly _id: string, readonly name: string }, readonly organisation: { readonly __typename?: 'FacilitySnapshot', readonly uuid: string, readonly name: string }, readonly clinic: { readonly __typename?: 'FacilitySnapshot', readonly _id?: string | null, readonly uuid: string, readonly name: string } } | null, readonly outcome?: { readonly __typename?: 'InvestigationRequestOutcome', readonly _id: string, readonly orderedProperties: ReadonlyArray<unknown | null>, readonly location?: { readonly __typename?: 'InvestigationLocationSnapshot', readonly _id: string, readonly name: string } | null, readonly performer: { readonly __typename?: 'ElephantActor', readonly _id: string, readonly name: string }, readonly organisation: { readonly __typename?: 'FacilitySnapshot', readonly uuid: string, readonly name: string }, readonly clinic: { readonly __typename?: 'FacilitySnapshot', readonly _id?: string | null, readonly uuid: string, readonly name: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null } | null };

export const InvestigationActivityFragmentFragmentDoc = gql`
    fragment InvestigationActivityFragment on InvestigationActivity {
  _id
  uuid
  void
  meta {
    created
    updated
  }
  clinicalEvent {
    id
    type
  }
  catalogueItem {
    _id
    title
    activityType
    coding {
      elephant {
        code
      }
      loinc {
        code
      }
    }
    keywords
    result {
      resultSchema
    }
    meta {
      created
      updated
    }
  }
  request {
    _id
    meta {
      created
    }
    location {
      _id
      name
    }
    performer {
      _id
      name
    }
    organisation {
      uuid
      name
    }
    clinic {
      _id
      uuid
      name
    }
    orderedProperties
  }
  outcome {
    _id
    location {
      _id
      name
    }
    performer {
      _id
      name
    }
    organisation {
      uuid
      name
    }
    clinic {
      _id
      uuid
      name
    }
    meta {
      created
      updated
    }
    orderedProperties
  }
}
    `;
export const ActiveInvestigationActivitiesDocument = gql`
    query ActiveInvestigationActivities {
  catalogueInvestigationActivities {
    id
    _id
    title
    keywords
    version
    activityType
    meta {
      created
    }
    coding {
      elephant {
        code
      }
      loinc {
        code
      }
    }
    result {
      resultSchema
    }
  }
}
    `;

/**
 * __useActiveInvestigationActivitiesQuery__
 *
 * To run a query within a React component, call `useActiveInvestigationActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveInvestigationActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveInvestigationActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveInvestigationActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<ActiveInvestigationActivitiesQuery, ActiveInvestigationActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveInvestigationActivitiesQuery, ActiveInvestigationActivitiesQueryVariables>(ActiveInvestigationActivitiesDocument, options);
      }
export function useActiveInvestigationActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveInvestigationActivitiesQuery, ActiveInvestigationActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveInvestigationActivitiesQuery, ActiveInvestigationActivitiesQueryVariables>(ActiveInvestigationActivitiesDocument, options);
        }
export type ActiveInvestigationActivitiesQueryHookResult = ReturnType<typeof useActiveInvestigationActivitiesQuery>;
export type ActiveInvestigationActivitiesLazyQueryHookResult = ReturnType<typeof useActiveInvestigationActivitiesLazyQuery>;
export type ActiveInvestigationActivitiesQueryResult = Apollo.QueryResult<ActiveInvestigationActivitiesQuery, ActiveInvestigationActivitiesQueryVariables>;
export const InvestigationsListHashDocument = gql`
    query InvestigationsListHash {
  catalogueInvestigationActivitiesLastUpdated
}
    `;

/**
 * __useInvestigationsListHashQuery__
 *
 * To run a query within a React component, call `useInvestigationsListHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestigationsListHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestigationsListHashQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestigationsListHashQuery(baseOptions?: Apollo.QueryHookOptions<InvestigationsListHashQuery, InvestigationsListHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestigationsListHashQuery, InvestigationsListHashQueryVariables>(InvestigationsListHashDocument, options);
      }
export function useInvestigationsListHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestigationsListHashQuery, InvestigationsListHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestigationsListHashQuery, InvestigationsListHashQueryVariables>(InvestigationsListHashDocument, options);
        }
export type InvestigationsListHashQueryHookResult = ReturnType<typeof useInvestigationsListHashQuery>;
export type InvestigationsListHashLazyQueryHookResult = ReturnType<typeof useInvestigationsListHashLazyQuery>;
export type InvestigationsListHashQueryResult = Apollo.QueryResult<InvestigationsListHashQuery, InvestigationsListHashQueryVariables>;